import {
  MenuProps,
  MenuItemProps,
  FeaturedImageProps,
} from "@made-people/blueprint-menu";

export const Foldout2MenuDefaults: MenuProps = {
  template: "foldout2",
  direction: "right",
  closeBtn: {
    placement: "inside",
  },
  header: {
    text: "",
  },
};

export const MenuItemDefaults: MenuItemProps = {
  badge: {
    variants: {
      color: "secondary",
      size: "sm",
    },
    rotate: 0,
  },
};

export const FeaturedImage: FeaturedImageProps = {};
